<template>
        <div class="card card-bottom-radius-8">
          <div class="card-header text-third">
            <strong> <div class = "Titulo">Total de Comissões</div></strong>
          </div>
            <div class = "dados">
            <div>
            <div class="d-flex align-items-center flex-column mt-5 mb-5">
            <div class="ConteudoQuitadas">
                {{ paidCommissions }}
            </div>
                <div class="comissionsInfo">Quitadas</div>
            </div>
           </div>
            <div class="separation"></div>

            <div class="d-flex align-items-center flex-column mt-5 mb-5">
           <div class="ConteudoAPagar">
                {{ commissionsPayable }}
            </div>
                <div class="comissionsInfo">À Pagar</div>
            </div>
            </div>
        </div>

</template>
<script>
import ComissoesTotal from './TotalComission'
export default ComissoesTotal
</script>

<style scoped>
    .Titulo{
        text-align: center;
    }
    .dados
    {
        display: flex;
        width:100%;
        align-items: center;
        justify-content: space-around;
    }

    .separation{
        background-color: rgba(78, 77, 77, 0.288);
        width: 1px;
        height: 64px;
    }
    .ConteudoQuitadas{
        height: 30px;
        font-size: 40px;
        color: #008148;
        display: flex;

    }
    .ConteudoAPagar
    {
        height: 30px;
        font-size: 40px;
        color: #008148;
        display:flex;
        justify-content: right;
    }

    .comissionsInfo{
        text-align: center;
    }

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/commissioncheck/components/TotalComission/TotalComission.vue